import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlRolesService } from '../ll-roles.service';

@Component({
  selector: 'll-model-census-switch',
  templateUrl: './ll-model-census-switch.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlModelCensusSwitchComponent {
  @ViewChild('mainDiv_ll_model_census_switch') mainDiv: ElementRef;
  @ViewChild('horzTabs_ll_model_census_switch') public horzTabs: ElementRef;

  constructor(
    private LlScrollpaneService: LlScrollpaneService,
    private LlRolesService: LlRolesService,
    private LlPermissionsService: LlPermissionsService,
  ) { }

  bundle = {
    showHorzTabs: false,
    showRemaining: false,
    function: '',
    LlScrollpaneService: this.LlScrollpaneService,
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 20,
    remainingW: 0,
    remainingH: 0,
    showTab: true,
    horzTabsY: 20,
    hTabW: 120,
    hTabH: 25,
    hTabIndent: 50,
    hTabIndx: 0,
    horzTabs: [],
    horzTabs_02: [],
    canvasHT: {},
    ctxHT: {},
  }

  ngOnInit() { }

  ngOnDestroy() { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingX = 0;
      this.bundle.remainingY = this.bundle.horzTabsY + this.bundle.hTabH + 3
      this.bundle.remainingW = this.bundle.parentW;;
      this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;

      var canvasHT: HTMLCanvasElement = this.horzTabs.nativeElement;
      this.bundle.canvasHT = canvasHT
      this.bundle.ctxHT = canvasHT.getContext('2d');

      this.getData()
    });
  }

  getData() {

    let SYSTEMROLEID = this.LlRolesService.getActiveContactRoleId();

    this.bundle.horzTabs.splice(0);

    this.bundle.horzTabs.push({ lbl: "Occupancy Pct" });
    this.bundle.horzTabs.push({ lbl: "Payer Class" });
    /*this.bundle.horzTabs.push({ lbl: "Collateral" });*/
    /*this.bundle.horzTabs.push({ lbl: "Locations" });*/


    this.LlScrollpaneService.paintHorzTab(horzTabSelected, this.bundle.horzTabs, this.bundle.canvasHT, this.bundle.ctxHT, this.bundle, false);

    function horzTabSelected(indx, bundle) {

      //if (indx === 2) {
      //  this.LlModelsService.setActiveSYSTEMOPERATIONREPORTSID(this.bundle.selectedId);
      //}


    }

    this.bundle.showHorzTabs = true;
    this.bundle.showRemaining = true;

  }


}

